import { GameObject } from "kontra";
import { SpaceItem } from "./spaceItem";

export class BackgroundItems extends GameObject {
  constructor() {
    super();
    const numOfComets = Math.floor(Math.random() * 8 + 4);
    const numOfStars1 = Math.floor(Math.random() * 20 + 15);
    const numOfStars2 = Math.floor(Math.random() * 20 + 15);

    const comets: SpaceItem[] = (new Array(numOfComets)).fill(null).map(_ => { return new SpaceItem('comet') })
    const stars1: SpaceItem[] = (new Array(numOfStars1)).fill(null).map(_ => { return new SpaceItem('stars1') })
    const stars2: SpaceItem[] = (new Array(numOfStars2)).fill(null).map(_ => { return new SpaceItem('stars2') })

    this.children.push(...comets, ...stars1, ...stars2);
  }
}